/**
 * Translation keys enum for top-area. Actual translation keys are values that are sent and returned from translation API are values of this object instead of keys
 */
export enum TranslationKeys {
  AllBrands = 'All brands',
  Articles = 'Articles',
  brands = 'brands',
  Change = 'Change',
  FailedToSubmit = 'FailedToSubmit',
  Loading = 'Loading',
  LogIn = 'Log in',
  Menu = 'Menu',
  MyAccount = 'MyAccount',
  MyFavouriteProducts = 'My favourite products',
  NoOptions = 'NoOptions',
  Other = 'Other',
  PopularProducts = 'Popular products',
  PopularProductsInThisSearchQuery = 'Popular products in this search query',
  PopularSearchQueries = 'Popular search queries',
  Products = 'Products',
  Register = 'Register',
  Search = 'Search',
  SeeAll = 'See all',
  SeeAllResultsFor = 'See all results for',
  ShopFor = 'Shop for',
  ShoppingBag = 'Shopping bag',
}
